import { CHAT_MEDIA_TYPES, type ChatMediaType } from 'cpool-constants';

import { DocumentDownloadRow } from './DocumentDownloadRow';
import { ImageAttachment } from './ImageAttachment';
import { InlineMediaAttachment } from './InlineMediaAttachment';
import { resolveChatAttachmentDownloadName } from '~/features/whatsapp/utils/resolveChatAttachmentDownloadName';

type Props = {
    chatId: string;
    mediaKey: string;
    mediaType: ChatMediaType;
    mediaFileName?: string | null;
    name?: string;
};

export const MessageAttachment = ({ chatId, mediaFileName, mediaKey, mediaType, name }: Props) => {
    const displayName = resolveChatAttachmentDownloadName({ mediaFileName, mediaKey, mediaType, name });

    if (mediaType === CHAT_MEDIA_TYPES.DOCUMENT) {
        return <DocumentDownloadRow chatId={chatId} displayName={displayName} mediaKey={mediaKey} />;
    }

    if (mediaType === CHAT_MEDIA_TYPES.IMAGE || mediaType === CHAT_MEDIA_TYPES.STICKER) {
        return (
            <ImageAttachment
                chatId={chatId}
                displayName={displayName}
                downloadName={displayName}
                mediaKey={mediaKey}
                name={name}
            />
        );
    }

    return <InlineMediaAttachment chatId={chatId} mediaKey={mediaKey} mediaType={mediaType} />;
};
